import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import type { Swiper as SwiperType } from "swiper";
import PublicacaoCard from "./PublicacaoCard";

interface PublicacaoSwiperProps {
  postagens: Array<{
    ID: number;
    Title: string;
    URL: string;
    Descricao: string;
    Data_x0020_Publicacao: string;
  }>;
  swiperIndex: number;
}

const PublicacaoSwiper: React.FC<PublicacaoSwiperProps> = ({
  postagens,
  swiperIndex,
}) => {
  return (
    <div className="publicacoes-swiper-container">
      <Swiper
        grabCursor={true}
        slidesPerView={4} // 4 cards por padrão no desktop
        spaceBetween={0}
        initialSlide={swiperIndex}
        pagination={{
          clickable: true,
          el: ".publicacoes-swiper-pagination",
        }}
        centeredSlides={false}
        allowTouchMove={true}
        watchOverflow={true}
        loop={false}
        breakpoints={{
          320: {
            slidesPerView: 1, // 1 card completo em mobile pequeno
            spaceBetween: 0,
            centeredSlides: true, // Centraliza o card
            initialSlide: 0,
          },
          480: {
            slidesPerView: 1, // 1 card completo em mobile pequeno
            spaceBetween: 0,
            centeredSlides: true, // Centraliza o card
            initialSlide: 0,
          },
          768: {
            slidesPerView: 2, // 2 cards em mobile/tablet
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
          991: {
            slidesPerView: 2, // 2 cards ao lado do texto
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
          1200: {
            slidesPerView: 3, // 3 cards em desktop médio
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
          1400: {
            slidesPerView: 4, // 4 cards em desktop grande
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
        }}
        style={{
          width: "100%",
          overflow: "visible",
        }}
      >
        {postagens.map((item, index) => (
          <SwiperSlide
            key={`publicacao-${item.ID}-${index}`}
            style={{
              width: "auto",
            }}
          >
            <PublicacaoCard item={item} />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Div para as bolinhas de paginação */}
      <div className="publicacoes-swiper-pagination"></div>
    </div>
  );
};

export default PublicacaoSwiper;
